const revenueBySales = (revenues: any) => {

  let gov,
    int,
    ret,
    ins,
    bra,
    val,
    rep,
    fle = {};

  revenues.forEach((revenue: any) => {
    if (revenue._id === "I") {
      int =
        revenue === undefined
          ? {
              name: "Internal",
              net: 0,
              profit: 0,
              list: [],
            }
          : {
              name: "Internal",
              net: revenue.net,
              profit: revenue.gross_profit,
              list: revenue.list,
            };
    }
    if (revenue._id === "G") {
      gov =
        revenue === undefined
          ? {
              name: "Government",
              net: 0,
              profit: 0,
              list: [],
            }
          : {
              name: "Government",
              net: revenue.net,
              profit: revenue.gross_profit,
              list: revenue.list,
            };
    }
    if (revenue._id === "R") {
      ret =
        revenue === undefined
          ? {
              name: "Retail",
              net: 0,
              profit: 0,
              list: [],
            }
          : {
              name: "Retail",
              net: revenue.net,
              profit: revenue.gross_profit,
              list: revenue.list,
            };
    }
    if (revenue._id === "H") {
      ins =
        revenue === undefined
          ? {
              name: "Insurance",
              net: 0,
              profit: 0,
              list: [],
            }
          : {
              name: "Insurance",
              net: revenue.net,
              profit: revenue.gross_profit,
              list: revenue.list,
            };
    }
    if (revenue._id === "B") {
      bra =
        revenue === undefined
          ? {
              name: "Branch",
              net: 0,
              profit: 0,
              list: [],
            }
          : {
              name: "Branch",
              net: revenue.net,
              profit: revenue.gross_profit,
              list: revenue.list,
            };
    }
    if (revenue._id === "V") {
      val =
        revenue === undefined
          ? {
              name: "Value +",
              net: 0,
              profit: 0,
              list: [],
            }
          : {
              name: "Value +",
              net: revenue.net,
              profit: revenue.gross_profit,
              list: revenue.list,
            };
    }
    if (revenue._id === "S") {
      rep =
        revenue === undefined
          ? {
              name: "Repair Shop",
              net: 0,
              profit: 0,
              list: [],
            }
          : {
              name: "Repair Shop",
              net: revenue.net,
              profit: revenue.gross_profit,
              list: revenue.list,
            };
    }
    if (revenue._id === "F") {
      fle =
        revenue === undefined
          ? {
              name: "Fleet",
              net: 0,
              profit: 0,
              list: [],
            }
          : {
              name: "Fleet",
              net: revenue.net,
              profit: revenue.gross_profit,
              list: revenue.list,
            };
    }
  });

  const data = [gov, ret, fle, val, int, rep, ins, bra];

  return data;
};

export default revenueBySales;
